<script setup>
    import { router } from '@inertiajs/vue3';
    import { onMounted, reactive, ref, watch } from 'vue';
    import JetFormSection from '@/Jetstream/SimpleFormSection.vue';
    import JetButton from '@/Jetstream/Button.vue';
    import JetButtonMinimal from '@/Jetstream/ButtonMinimal.vue';
    import JetDialogModalForm from '@/Jetstream/DialogModalForm.vue';
    import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue';
    import Comment from '@/Pages/Toolkit/Partials/Comment';
    import AuditorComment from '@/Pages/Toolkit/Partials/AuditorComment';
    import Evidence from '@/Pages/Toolkit/Partials/Evidence';
    import CustomField from '@/Pages/Toolkit/Partials/CustomField.vue';
    import { QuillEditor, Delta } from '@vueup/vue-quill'
    import '@vueup/vue-quill/dist/vue-quill.snow.css';
    import multiselect from '@vueform/multiselect';
    import debounce from 'lodash.debounce';
    import Datepicker from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css';

    const enabling = ref(false);

    const props = defineProps({
        toolkit: Object,
        action: Object,
        loggedInUserId: Number,
        currentToolkitTeamUsers: Array,
        errors: Object,
        filters: Object,
        team: Object,
        auditor: Boolean,
        auditorSession: Object,
        adminAudit: Boolean,
        pastToolkit: Boolean,
        adminToolkit: Boolean,
        adminInfo: Object,
        currentActiveToolkit: Boolean,
      });

    // Get the Programme, Organisation, and props we need to get the user preferred locale
    let programme = null;
    let organisation = null;

    if(props.adminToolkit && props.adminInfo) {
        programme = props.adminInfo['programme'];
        organisation = props.adminInfo['organisation'];
    } else {
        programme = router.page.props.ziggy.programme;
        organisation = router.page.props.ziggy.organisation;
    }

    const dateRequiredBy = ref();

    const urlNamePrefix = organisation ? "gi." : "";

    let activeTab = ref(1);

    const user = router.page.props.auth.user;

    let preview = false;
    if (router.page.props.preview) {
        preview = router.page.props.preview;
    }

    let auditor = false;
    if (router.page.props.auditor) {
        auditor = router.page.props.auditor;
    }

    const uploadEvidence = ref(false);
    const deleteConfirm = ref(false);
    const modalSize = 'xxl';

    const commentEditor = ref('commentEditor');
    const auditorCommentEditor = ref('auditorCommentEditor');

    const uploadFile = ref('upload_file');

    const action_audit = reactive({
        values: {
            id: null,
            action_id: null,
            audit_id: null,
            auditor_code_id: null,
            toolkit_id: null,
            team_id: null,
            status_accepted: null,
            amended_status_id: Number,
            further_evidence_required: null,
            evidence_required_by: null,
            amended_points_value: null
        }
    });

    const emit = defineEmits(['statusChanged']);

    const statusChanged = (status) => {
        emit('statusChanged', props.action, status);
    }

    let editable = true;

    if ((props.pastToolkit && !props.currentActiveToolkit) || props.toolkit.locked || props.adminToolkit) {
        editable = false;
    }

    let evidence = false;
    let auditorSession = '';

    // if in preview mode, set IDs for programme (and organisation if appropriate) from toolkit object
    if (preview == true) {
        if (props.toolkit.organisation != null) {
            organisation = props.toolkit.organisation;
        }
        programme = props.toolkit.programme;
    }

    if (auditor) {
        if (props.action.action_audit && Object.keys(props.action.action_audit).length > 0) {
            action_audit.values = {...action_audit.values, ...Object.values(props.action.action_audit)[0]};
        }

        if (props.action.evidence.length != 0) {
            evidence = true;
        }
        auditorSession = props.auditorSession;
    }

    let actionID = '';
    const actionReference = props.action.reference.toLowerCase();
    //actionID = actionReference.replace(/\s/g, '');
    // Replace spaces and special characters with underscores.
    actionID = actionReference.replace(/[&\/\\#, +()$~%.'":*?!£^<>{}]/g, '_');

    const convertToObject = (json) => {
        if (json.constructor.name != 'Object') {
            json = JSON.parse(json)
        }
        return json;
    }


    const actionAssignedUserID = 'action-assigned-' + actionID;
    const actionAssignUserSelectWrapper = 'action-user-select-wrapper-' + actionID;
    const actionAssignUserSelect = 'action-user-select-' + actionID;
    const actionAssignButtonID = 'action-button-' + actionID;
    const actionAssignUserTriggerID = 'assign-user-trigger-'  + actionID;

    const auditorChangeActionStatusSelectWrapper = 'auditor-action-change-status-wrapper-' + actionID;
    const auditorChangeActionStatusID = 'auditor-action-change-status-' + actionID;
    const auditorChangeActionStatusButtonID = 'auditor-action-change-status-button-' + actionID;
    const auditorActionFurtherEvidenceID = 'auditor-action-further-evidence-' + actionID;
    const auditorChangeActionPointsID = 'auditor-change-action-points' + actionID;
    const auditorDownloadActionEvidenceID = 'auditor-download-action-evidence-' + actionID;
    const auditorRequiredByID = 'auditor-requiredby-' + actionID;

    const carbonAnswer = ref(props.action.carbon_saving_metric_question_answer);

    const filepath = '/storage/';

    const validation_error = reactive({
        file_path: "",
        comment: "",
    });

    onMounted(() => {
        const trigger = '#' + actionAssignUserTriggerID;
        const expandable = '#' + actionAssignUserSelectWrapper;
        $(trigger).on('click', function (e) {
            e.preventDefault();
            $(expandable).slideToggle();
        });
    });


    const form = reactive({
        userComment: '',
        userDraftCommentID: '',
        userDraftLastSaved: '',
    });

    const auditorCommentForm = reactive({
        auditorComment: '',
        auditorDraftCommentID: '',
        auditorDraftLastSaved: '',
    });


    // autosave shananigains for user comments
    const actionComments = props.action.comments;

    if (actionComments === undefined || actionComments.length == 0) {
        // array does not exist or is empty
    }
    else {
        for (const key in actionComments) {
            const actionComment = actionComments[key];
            if (user) {
                if (actionComment.draft == 1 && actionComment.user_id == user.id) {
                    form.userComment = actionComment.comment;
                    form.userDraftCommentID = actionComment.id;
                    form.userDraftLastSaved = actionComment.updated_at;
                }
            }
        }
    }

    // autosave shananigains for user auditor comments if we are in auditor mode
    if (auditor) {
        const auditorComments = props.action.auditor_comments;

        if (auditorComments === undefined || auditorComments.length == 0) {
            // array does not exist or is empty
        }
        else {
            for (const key in auditorComments) {
                const auditorComment = auditorComments[key];
                if (props.auditorSession) {
                    if (auditorComment.draft == 1 && auditorComment.auditor_code_id == props.auditorSession.auditor_code_id) {
                        auditorCommentForm.auditorComment = auditorComment.comment;
                        auditorCommentForm.auditorDraftCommentID = auditorComment.id;
                        auditorCommentForm.auditorDraftLastSaved = auditorComment.updated_at;
                    }
                }
            }
        }
    }

    const evidenceForm = reactive({
        file_path: ''
    });

    const refresh  = () => {
        router.reload({ preserveState: true });
    }

    const clearValidation = () => {
        validation_error.comment = "";
        form.userComment = "";
    }

    const saveComment = (e) => {

        router.put(route(urlNamePrefix+'action-comments.store'),
        {
            comment: form.userComment,
            action_id: props.action.id,
            toolkit_id: props.toolkit.toolkit_id,
            filters: props.filters,
            comment_id: form.userDraftCommentID,
            draft: false,
            pastToolkit: props.pastToolkit
        }, {
            preserveState: true,
            preserveScroll: true,
            onSuccess: page => {
                form.userComment = "";
                form.userDraftCommentID = '';
                form.userDraftLastSaved = '';
                commentEditor.value.setHTML(null);
                validation_error.comment = "";
            },
            onError: (errors) => {
                validation_error.comment = errors.comment;
            },
        });
    }

    const saveAuditorComment = (e) => {

        router.put(route(urlNamePrefix+'auditor.auditor-comments.store', {'subdomain':'auditor'}),
        {
            comment: auditorCommentForm.auditorComment,
            action_id: props.action.id,
            toolkit_id: props.toolkit.toolkit_id,
            filters: props.filters,
            comment_id: auditorCommentForm.auditorDraftCommentID,
            audit_id: props.auditorSession.audit.id,
            auditor_code_id: props.auditorSession.auditor_code_id,
            auditor_name: props.auditorSession.auditor_name,
            team_id: props.auditorSession.team,

            draft: false,
        }, {
            preserveState: true,
            preserveScroll: true,
            onSuccess: page => {
                auditorCommentForm.auditorComment = "";
                auditorCommentForm.auditorDraftCommentID = '';
                auditorCommentForm.auditorDraftLastSaved = '';
                auditorCommentEditor.value.setHTML(null);
                validation_error.comment = "";
            },
            onError: (errors) => {
                validation_error.auditorComment = errors.comment;
            },
        });
    }

    const uploadEvidenceModal = () => {
        uploadEvidence.value = true;
    };

    const deleteModal = () => {
        deleteConfirm.value = true;
    };

    const Upload = () => {

        router.post(route(urlNamePrefix+'action-evidence.store'),
        {
            file_path: evidenceForm.file_path,
            action_id: props.action.id,
            action_reference: props.action.reference,
            toolkit_id: props.toolkit.toolkit_id,
            filters: props.filters,
            pastToolkit: props.pastToolkit
        },
        {
            forceFormData: true,
            preserveScroll: true,
            onSuccess: () => Promise.all([
                uploadEvidence.value = false,
                evidenceForm.file_path = null,
                validation_error.file_path = ""
            ]),
            onError: (errors) => {
                validation_error.file_path = errors.file_path;
            },
        });



    };

    const closeModal = () => {
        uploadEvidence.value = false;
        validation_error.file_path = '';
    };

    let getSiblings = function (e) {
            // for collecting siblings
            let siblings = [];
            // if no parent, return no sibling
            if(!e.parentNode) {
                return siblings;
            }
            // first child of the parent node
            let sibling  = e.parentNode.firstChild;
            // collecting siblings
            while (sibling) {
                if (sibling.nodeType === 1 && sibling !== e) {
                    siblings.push(sibling);
                }
                sibling = sibling.nextSibling;
            }
            return siblings;
    };

    const getStarStyle = (action_starred) => {

        let starType = 'star_outline';
        if ( action_starred == 0 ) {
            starType = 'star_outline';
        }
        else {
            starType = 'star';
        }

        return starType;
    }

    const UpdateActionStarred = ($event, starred) => {


        let actionStarred = starred;

        // Set boolean to opposite to current
        if ( actionStarred == 0 ) {
            actionStarred = 1;
        }
        else {
            actionStarred = 0;
        }

        router.post(route(urlNamePrefix+'action-user-starred.update'),
        {
            action_id: props.action.id,
            action_starred: actionStarred,
            updated_by: user.id,
            current_team_id: user.current_team_id,
            filters: props.filters,
            toolkit_id: props.toolkit.toolkit_id,
            pastToolkit: props.pastToolkit

        }, {
            preserveState: true,
            preserveScroll: true,
            replace: true,

            onSuccess: function() {

            // noooooo, we do not need to do this. Trust the state updating the UX. This is the way x
            // ======================================================================================

            //     let starType = $event.target;
            //     if ( props.action.action_starred == 0 ) {
            //         starType.innerHTML = 'star_outline';
            //     }
            //     else {
            //         starType.innerHTML = 'star';
            //     }
             }

        });

    }

    const UpdateActionStatus = ($event, status) => {

        router.post(route(urlNamePrefix+'action-team-status.update'),
        {
            action_id: status.action_id,
            action_status: status.id,
            updated_by: user.id,
            current_team_id: user.current_team_id,
            filters: props.filters,
            toolkit_id: props.toolkit.toolkit_id,
            pastToolkit: props.pastToolkit

        }, {
            preserveState: true,
            preserveScroll: true,
            replace: true,
            onSuccess: function() {
                statusChanged(status);

                // noooooo, we do not need to do this. Trust the state updating the UX. This is the way x
                // ======================================================================================

                // let actionStatus = status.id;
                // //console.log(actionStatus);

                // if ($event.target.classList.contains('btn-toolkit-secondary')) {
                //     $event.target.classList.add('btn-toolkit-primary');
                //     $event.target.classList.remove('btn-toolkit-secondary');

                //     let current_button = $event.target;
                //     let siblings = getSiblings(current_button);

                //     siblings.forEach(sibling => {
                //         sibling.classList.remove('btn-toolkit-primary');
                //         sibling.classList.add('btn-toolkit-secondary');
                //     });

                // }
            }

        });

    }

    const assignedUser = reactive({
            user_id: 0,
            username: null
    });

    let current_team_id = '';

    if (auditor) {
        current_team_id = auditorSession.team;
    }
    else {
        current_team_id = user.current_team_id;
    }

    const UpdateAssignedUser = (e) => {

        router.post(route(urlNamePrefix+'action-assign-user.update'),
        {
            action_id: props.action.id,
            assigned_user: assignedUser.user_id,
            current_team_id: current_team_id,
            filters: props.filters,
            toolkit_id: props.toolkit.toolkit_id,
            pastToolkit: props.pastToolkit

        }, {
            //forceFormData: true,
            preserveState: true,
            preserveScroll: true,
            replace: true,
            onSuccess: function() {
                console.log("Updated successfully.");
            },
            onError: (errors) => {
                //validation_error.file_path = errors.file_path;
            },

        });

    }

    const getTranslatedActionStatus = (statusID) => {

        let translatedActionStatusButtonLabel = '';

        if ( statusID == 1 ) {
            translatedActionStatusButtonLabel = 'done';
        }
        else if ( statusID == 2 ) {
            translatedActionStatusButtonLabel = 'in_progress';
        }
        else if ( statusID == 3 ) {
            translatedActionStatusButtonLabel = 'not_done';
        }
        else if ( statusID == 4 ) {
            translatedActionStatusButtonLabel = 'not_applicable';
        }
        else {
            translatedActionStatusButtonLabel = 'none';
        }
        return translatedActionStatusButtonLabel;
    }

    const dateOptions = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric'
    };

    function formatDate(date, time = true) {
        date = new Date(date);
        if (time) {
            return date.toLocaleDateString('en-uk', dateOptions);
        } else {
            return date.toLocaleDateString('en-uk', {year: 'numeric', month: 'numeric', day: 'numeric'});
        }
    }

    const updateDraftComment = debounce(() => {

        router.put(route(urlNamePrefix+'action-comments.store'),
        {
            comment: form.userComment,
            action_id: props.action.id,
            toolkit_id: props.toolkit.toolkit_id,
            filters: props.filters,
            draft: true,
            comment_id: form.userDraftCommentID,
            pastToolkit: props.pastToolkit
        }, {
            preserveState: true,
            preserveScroll: true,
            onSuccess: (response) => {
                // Get updated list of comments for this action
                const actionComments  = props.action.comments;
                // Check if a draft comment exists for this action and user.
                // if one exists, update the reactive variables accordingly.
                if ( actionComments ) {
                    let comments = Object.values(actionComments);

                    comments.forEach(function (comment) {
                        if ( comment.draft == 1 && comment.user_id == user.id ) {
                            form.userComment = comment.comment;
                            form.userDraftCommentID = comment.id;
                            form.userDraftLastSaved = comment.updated_at;
                        }
                    });
                }
            },
            onError: (errors) => {
                validation_error.comment = errors.comment;
            },
        });
        // Poll every 30 seconds
     }, 30000);

    watch(form, () => {
       updateDraftComment()
    });

    if (auditor) {
        const updateDraftAuditorComment = debounce(() => {

            router.put(route(urlNamePrefix+'auditor.auditor-comments.store', {'subdomain':'auditor'}),
            {
                comment: auditorCommentForm.auditorComment,
                action_id: props.action.id,
                toolkit_id: props.toolkit.toolkit_id,
                filters: props.filters,
                comment_id: auditorCommentForm.auditorDraftCommentID,
                audit_id: props.auditorSession.audit.id,
                auditor_code_id: props.auditorSession.auditor_code_id,
                auditor_name: props.auditorSession.auditor_name,
                team_id: props.auditorSession.team,
                draft: 1,
                comment_id: auditorCommentForm.auditorDraftCommentID
            }, {
                preserveState: true,
                preserveScroll: true,
                onSuccess: (response) => {
                    // Get updated list of comments for this action
                    const actionAuditorComments  = props.action.auditor_comments;
                    // Check if a draft comment exists for this action and user.
                    // if one exists, update the reactive variables accordingly.
                    if ( actionAuditorComments ) {
                        let acomments = Object.values(actionAuditorComments);

                        acomments.forEach(function (comment) {
                            if ( comment.draft == 1 && comment.auditor_code_id == props.auditorSession.auditor_code_id ) {
                                auditorCommentForm.auditorComment = comment.comment;
                                auditorCommentForm.auditorDraftCommentID = comment.id;
                                auditorCommentForm.auditorDraftLastSaved = comment.updated_at;
                            }
                        });
                    }
                },
                onError: (errors) => {
                    validation_error.comment = errors.comment;
                },
            });
            // Poll every 30 seconds
        }, 30000);

        watch(auditorCommentForm, () => {
            updateDraftAuditorComment()
        });
    }

    const arrayOfStatuses = Object.keys(props.action.statuses).map(key => {
        return props.action.statuses[key];
    })

    // auditor action functions

    // accept action status

    const auditorAcceptStatus = (e) => {

        router.post(route(urlNamePrefix+'auditor.audit-action.accept-status', {'subdomain':'auditor'}),
        {

            action_id: props.action.id,
            audit_id: props.auditorSession.audit.id,
            auditor_code_id: props.auditorSession.auditor_code_id,
            toolkit_id: props.toolkit.toolkit_id,
            team_id: props.auditorSession.team,
            filters: props.filters

        }, {
            preserveState: true,
            preserveScroll: true,
            replace: true,
            onSuccess: function() {
                action_audit.values = {...action_audit.values, ...Object.values(props.action.action_audit)[0]};
            }
        });
    }

    // further evidence required

    const furtherEvidenceRequired = (e) => {

        router.post(route(urlNamePrefix+'auditor.audit-action.further-evidence-required', {'subdomain':'auditor'}),
        {

            action_id: props.action.id,
            audit_id: props.auditorSession.audit.id,
            auditor_code_id: props.auditorSession.auditor_code_id,
            toolkit_id: props.toolkit.toolkit_id,
            team_id: props.auditorSession.team,
            filters: props.filters

        }, {
            preserveState: true,
            preserveScroll: true,
            replace: true,
            onSuccess: function() {
                action_audit.values = {...action_audit.values, ...Object.values(props.action.action_audit)[0]};
            }
        });
    }

    const isFurtherEvidenceRequired = (e) => {
        if (action_audit.values && action_audit.values.further_evidence_required == true) {
            return true;
        } else {
            return false;
        }
    }

    const amendedStatus = reactive({
        statusLabel: ''
    });

    const getStatusLabel = (id) => {
        if ( id == 1 ) {
            return 'Done';
        } else if  ( id == 2 ) {
            return 'In Progress';
        } else if  ( id == 3 ) {
            return 'Not Done';
        } else if  ( id == 4 ) {
            return 'N/A';
        } else {
            return 'Unset';
        }
    }

    amendedStatus.statusLabel = getStatusLabel(action_audit.values.amended_status_id);

    const auditorChangeStatus = (e) => {
        action_audit.values.amended_status_id = e;
        amendedStatus.statusLabel = getStatusLabel(action_audit.values.amended_status_id);

        router.post(route(urlNamePrefix+'auditor.audit-action.amend-status', {'subdomain':'auditor'}),
        {

            action_id: props.action.id,
            audit_id: props.auditorSession.audit.id,
            auditor_code_id: props.auditorSession.auditor_code_id,
            toolkit_id: props.toolkit.toolkit_id,
            team_id: props.auditorSession.team,
            amended_status_id: action_audit.values.amended_status_id,
            filters: props.filters

        }, {
            preserveState: true,
            preserveScroll: true,
            replace: true,
            onSuccess: function() {
                if (action_audit.values.amended_status_id == 1) { //if we have changed this status to done
                    if (props.action.carbon_saving &&
                    props.action.carbon_saving_type == 'per' &&
                    !props.action.carbon_saving_metric_question_answer) { //if we ahve carbon savinsg of type 'per' without an answer
                        auditorUpdateCarbonSavingAnswer(e, 1); //set the answer to 1
                    }
                }
            }
        });

    }

    const auditorUpdateCarbonSavingAnswer = ($event, answer) => {
        router.post(route(urlNamePrefix+'auditor.audit-action.amend-action-team-carbon-answer', {'subdomain':'auditor'}),
        {
            action_id: props.action.id,
            action_team_id: props.action.action_team_id,
            filters: props.filters,
            answer: answer
        }, {
            preserveState: true,
            preserveScroll: true,
            replace: true,
            onSuccess: function() {
                carbonAnswer.value = props.action.carbon_saving_metric_question_answer;
            }

        });
    }

    const auditorClearStatus = (e) => {
        action_audit.values.amended_status_id = null;
        amendedStatus.statusLabel = 'Unset';
    }

    const auditorEvidenceRequiredByDate = (e) => {

        router.post(route(urlNamePrefix+'auditor.audit-action.evidence-required-by-date', {'subdomain':'auditor'}),
        {

            action_id: props.action.id,
            audit_id: props.auditorSession.audit.id,
            auditor_code_id: props.auditorSession.auditor_code_id,
            toolkit_id: props.toolkit.toolkit_id,
            team_id: props.auditorSession.team,
            evidence_required_by: action_audit.values.evidence_required_by,
            filters: props.filters

        }, {
            preserveState: true,
            preserveScroll: true,
            replace: true,
            onSuccess: function() {

            }
        });
    }

    const auditorChangeActionPoints = (e) => {

        router.post(route(urlNamePrefix+'auditor.audit-action.change-action-points', {'subdomain':'auditor'}),
        {

            action_id: props.action.id,
            audit_id: props.auditorSession.audit.id,
            auditor_code_id: props.auditorSession.auditor_code_id,
            toolkit_id: props.toolkit.toolkit_id,
            team_id: props.auditorSession.team,
            amended_points_value: action_audit.values.amended_points_value,
            filters: props.filters

        }, {
            preserveState: true,
            preserveScroll: true,
            replace: true,
            onSuccess: function() {

            }
        });

    }

    const urlSlugForAuditor = (organisation === undefined || organisation === null) ? '/'+programme.slug : '/' + programme.slug + '/' + organisation.slug;

    function downloadEvidenceForAction() {
        enabling.value = true;
        return axios.get(urlSlugForAuditor + '/toolkit/' + props.toolkit.toolkit_id + '/action/' + props.action.id + '/evidence',
        { responseType: 'arraybuffer' })
        .then(response => {
            let fileName = downloadFile(response);
            enabling.value = false;

            return axios.post(urlSlugForAuditor + '/toolkit/' + props.toolkit.toolkit_id + '/deleteEvidence', {
                filePath: fileName
            });
        })
        .catch(function (error) {
            enabling.value = false;
        });
    }

    function downloadFile(response) {
        const blob = new Blob([response.data], {type: response.data.type});

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob)
            return
        }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        //get the filename from the response headers
        const contentDisposition = response.headers['content-disposition'];
        let fileName = 'Evidence.zip';
        if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename=(.+)/);
            if (fileNameMatch.length === 2)
                fileName = fileNameMatch[1];
        }
        link.setAttribute('download', fileName);

        //click the link to download the file
        link.click();

        //clean up
        link.remove();
        setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(url)
        }, 100)

        return fileName;
    }

    const UpdateCarbonSavingAnswer = ($event, answer) => {
        router.post(route(urlNamePrefix+'action-team-carbon-answer.update'),
        {
            action_id: props.action.id,
            action_team_id: props.action.action_team_id,
            updated_by: user.id,
            current_team_id: user.current_team_id,
            filters: props.filters,
            toolkit_id: props.toolkit.toolkit_id,
            pastToolkit: props.pastToolkit,
            adminToolkit: props.adminToolkit,
            answer: answer
        }, {
            preserveState: true,
            preserveScroll: true,
            replace: true,
            onSuccess: function() {
                // statusChanged(status);
            }

        });
    }

    // toolkit.display_carbon_savings && action.carbon_saving && (team && team.enable_carbon_savings
    //console.log(toolkit.display_carbon_savings);
    //console.log(action.carbon_saving);
    //console.log(team);
    //console.log(team.enable_carbon_savings);

</script>

<template>

    <div :id="actionID" class="flex-wrap justify-between w-full p-5 pb-10 mb-5 action-item xl:flex rounded-2xl" :class="{ 'inactive': action.inactive, 'hidden': (action.inactive && !actionStatus) || (action.inactive && actionStatus > 2)}">
        <p v-if="action.inactive" class="inactive-text">{{ $t('toolkit.action.inactive') }}</p>
        <div class="action-item-inner action-item-content">
            <div class="items-center mb-5 md:flex">

                <div class="flex items-center">
                    <JetButtonMinimal
                        v-if="!auditor"
                        type="button"
                        class="pr-2 material-icons-outlined star display-inherit"
                        :disabled="preview || !editable"
                        v-on:click="UpdateActionStarred($event, props.action.action_starred)"
                    >
                        <span class="material-icons-outlined star">{{ getStarStyle(props.action.action_starred) }}</span>
                    </JetButtonMinimal>

                    <h3 class="action-title">{{action.reference}}</h3>
                </div>

                <ul class="align-middle action-tags md:flex">
                    <li v-for="labels in props.action.actions_labels" class="action-tag" :style="{ backgroundColor: labels.theme_colour }" >
                        <div v-if="convertToObject(labels.name)[$i18n.locale] || convertToObject(labels.name)[$i18n.fallbackLocale]" v-html="convertToObject(labels.name)[$i18n.locale] ? convertToObject(labels.name)[$i18n.locale] : convertToObject(labels.name)[$i18n.fallbackLocale]"></div>
                    </li>
                </ul>
            </div>
            <div class="action-item-content-tabs">

                <ul class="action-tab-controls">
                    <li><a data-id="tab1" class="tab tab1" v-on:click="activeTab=1" v-bind:class="[ activeTab === 1 ? 'active' : '' ]">{{ $t('toolkit.action.criteria_tab') }}</a></li>
                    <li><a data-id="tab2" class="tab tab2" v-on:click="activeTab=2" v-bind:class="[ activeTab === 2 ? 'active' : '' ]">{{ $t('toolkit.action.information_tab') }}</a></li>
                    <li><a data-id="tab3" class="tab tab3" v-on:click="activeTab=3" v-bind:class="[ activeTab === 3 ? 'active' : '' ]">{{ $t('toolkit.action.audited_tab') }}</a></li>
                    <li><a data-id="tab4" class="tab tab4" v-on:click="activeTab=4" v-bind:class="[ activeTab === 4 ? 'active' : '' ]">{{ $t('toolkit.action.comments_tab') }}</a></li>
                </ul>

                <div class="action-tab-content sm:flex tab1" data-content="tab1" v-bind:class="[ activeTab === 1 ? 'active' : '' ]">
                    <h4 class="font-bold print-only">{{ $t('toolkit.action.criteria_tab') }}</h4>
                    <div v-if="convertToObject(props.action.criteria)[$i18n.locale] || convertToObject(props.action.criteria)[$i18n.fallbackLocale]" v-html="convertToObject(props.action.criteria)[$i18n.locale] ? convertToObject(props.action.criteria)[$i18n.locale] : convertToObject(props.action.criteria)[$i18n.fallbackLocale]" class="content-inner sm:basis-3/4 sm:pr-3"></div>

                    <div class="flex flex-wrap content-start sdg-wrapper sm:basis-1/4">
                        <div v-for="sdg in action.sdgs" class="sdg-image-wrapper basis-1/2">
                            <img :src="filepath+sdg.image" :alt="sdg.alt ? sdg.alt : sdg.name" class="sdg-image" />
                        </div>
                    </div>
                </div>

                <div class="flex action-tab-content tab2" data-content="tab2" v-bind:class="[ activeTab === 2 ? 'active' : '' ]">
                    <h4 class="font-bold print-only">{{ $t('toolkit.action.information_tab') }}</h4>
                    <div v-if="convertToObject(props.action.information)[$i18n.locale] || convertToObject(props.action.information)[$i18n.fallbackLocale]" v-html="convertToObject(props.action.information)[$i18n.locale] ? convertToObject(props.action.information)[$i18n.locale] : convertToObject(props.action.information)[$i18n.fallbackLocale]" class="content-inner"></div>
                </div>

                <div class="flex action-tab-content tab3" data-content="tab3" v-bind:class="[ activeTab === 3 ? 'active' : '' ]">
                    <h4 class="font-bold print-only">{{ $t('toolkit.action.audited_tab') }}</h4>
                    <div v-if="convertToObject(props.action.audited)[$i18n.locale] || convertToObject(props.action.audited)[$i18n.fallbackLocale]" v-html="convertToObject(props.action.audited)[$i18n.locale] ? convertToObject(props.action.audited)[$i18n.locale] : convertToObject(props.action.audited)[$i18n.fallbackLocale]" class="content-inner"></div>
                </div>

                <div class="flex flex-col action-tab-content tab4" data-content="tab4" v-bind:class="[ activeTab === 4 ? 'active' : '' ]">
                    <h4 class="font-bold print-only">{{ $t('toolkit.action.comments_tab') }}</h4>
                    <span class="pb-2">{{ $t('toolkit.action.comments') }}:</span>
                    <Comment v-for="comment in action.comments" :comment="comment" :loggedInUserId="loggedInUserId" :pastToolkit="props.pastToolkit" :toolkit_id="props.toolkit.toolkit_id" :editable="editable" :filters="props.filters" />
                    <div class="pt-5 comment-editor" v-if="!auditor && editable">
                        <QuillEditor
                            ref="commentEditor"
                            v-model:content="form.userComment"
                            ctheme="snow"
                            contentType="html"
                             />
                             <div v-if="form.userDraftLastSaved" class="mt-1 text-xs text-gray-500 last-updated">{{ $t('toolkit.comment.last_updated') }}: {{ formatDate(form.userDraftLastSaved) }}</div>
                        <div class="w-full pt-3">
                            <JetButton
                            :disabled='action.inactive || preview || !editable'
                            type="button"
                            class="justify-center block mb-2 rounded btn-save-comment btn btn-action-control btn-toolkit-primary sm:float-right"
                            v-on:click="saveComment($event)"
                            >
                            {{ $t('toolkit.action.save_comment') }}
                            </JetButton>
                        </div>
                        <span class="text-red-500">{{validation_error.comment}}</span>
                    </div>
                    <span :class="auditor ? 'mt-5' : ''" class="pb-2">{{ $t('toolkit.action.evidence') }}:</span>
                    <Evidence v-for="evidence in action.evidence" :evidence="evidence" :loggedInUserId="loggedInUserId" :pastToolkit="props.pastToolkit" :toolkit_id="props.toolkit.toolkit_id" :editable="editable" :filters="props.filters" />
                    <div class="pt-5">
                        <div class="w-full pt-3" v-if="editable">
                            <JetButton
                            :disabled='action.inactive || preview || auditor || !editable'
                            type="button"
                            class="justify-center block mb-2 rounded btn-upload-evidence btn btn-action-control btn-toolkit-primary sm:float-right"
                            v-on:click="uploadEvidenceModal($event)"
                            >
                            {{ $t('toolkit.action.add_evidence') }}
                            </JetButton>
                        </div>
                    </div>

                    <div v-if="props.action.customFields && props.action.customFields.length !== 0">
                        <p class="mb-5 ">{{ $t('toolkit.action.custom_fields') }}:</p>
                        <CustomField v-for="custom_field in props.action.customFields" :custom_field="custom_field" :key="custom_field.id" :action_id="props.action.id" :loggedInUserId="loggedInUserId" :filters="props.filters" />
                    </div>

                </div>
            </div>
        </div>
        <div class="action-item-inner action-item-controls">
            <div class="p-5 mb-5 text-center card-item action-card-item action-card-controls rounded-2xl">
                <h4 class="mb-2" v-if="props.toolkit.scoring == 'Points'">{{ $t('toolkit.action.total_points') }}: {{action.points}}</h4>
                <div class="button-group">
                    <JetButton
                        :disabled='action.inactive || preview || auditor || !editable'
                        v-for="status in action.statuses"
                        :status="status.id"
                        :actionstatus="action.actionCurrentStatus"
                        :class="action.actionCurrentStatus == status.id ? 'btn-toolkit-primary' : 'btn-toolkit-secondary'"
                        :loggedInUserId="loggedInUserId"
                        type="button"
                        class="justify-center block w-full mb-2 btn btn-action-control"
                        v-on:click="UpdateActionStatus($event, status);"
                    >
                    {{ $t( 'dashboard.widgets.shared.status.' + getTranslatedActionStatus(status.id)) }}
                    </JetButton>
                </div>
            </div>
            <div class="p-5 mb-5 text-center card-item action-card-item action-card-controls rounded-2xl" v-if="toolkit.display_carbon_savings && action.carbon_saving && (team && team.enable_carbon_savings || !team)">
                <!-- <h4 class="mb-2" v-if="props.toolkit.scoring == 'Points'">{{ $t('toolkit.action.carbon_savings.title') }}</h4> -->
                <p>{{ $t('toolkit.action.carbon_savings.saving') }}</p>
                <p class="text-lg font-extrabold" v-html="$t('toolkit.action.carbon_savings.co2', { carbon_total: action.carbon_saving })"></p>
                <p v-if="action.carbon_saving_type == 'per'">
                    {{ action.carbon_saving_type }} 
                    <span v-if="convertToObject(props.action.carbon_saving_metric)[$i18n.locale] || convertToObject(props.action.carbon_saving_metric)[$i18n.fallbackLocale]" v-html="convertToObject(props.action.carbon_saving_metric)[$i18n.locale] ? convertToObject(props.action.carbon_saving_metric)[$i18n.locale] : convertToObject(props.action.carbon_saving_metric)[$i18n.fallbackLocale]"></span>

                </p>
                <hr v-if="action.carbon_saving_type == 'per'" style="margin-bottom: 10px;"/>
                <p v-if="action.carbon_saving_type == 'per'">
                    <span v-if="convertToObject(props.action.carbon_saving_metric_question)[$i18n.locale] || convertToObject(props.action.carbon_saving_metric_question)[$i18n.fallbackLocale]" v-html="convertToObject(props.action.carbon_saving_metric_question)[$i18n.locale] ? convertToObject(props.action.carbon_saving_metric_question)[$i18n.locale] : convertToObject(props.action.carbon_saving_metric_question)[$i18n.fallbackLocale]"></span>
                </p>
                <div v-if="action.carbon_saving_type == 'per'" class="flex flex-row justify-center" style="height: 40px">
                    <input
                        type="number"
                        v-model="carbonAnswer"
                        :disabled='action.inactive || preview || auditor || !editable'
                        class="w-1/2 mr-2 border-gray-300 rounded-md shadow-sm action-custom-field grow focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                    />
                    <JetButton
                        type="button"
                        class="justify-center block w-1/2 rounded action-custom-field-button btn btn-action-control btn-toolkit-primary"
                        v-on:click="UpdateCarbonSavingAnswer($event, carbonAnswer)"
                        :disabled='action.inactive || preview || auditor || !editable'
                    >
                        {{ $t('toolkit.custom_field.save') }}
                    </JetButton>
                </div>
            </div>
        </div>
        <div class="assigned-to">
            <div class="flex items-center">
                <div class="pr-3 font-bold">{{ $t('toolkit.action.assigned_to') }}:</div>
                <div class="pr-3 assigned-user" :id="actionAssignedUserID" v-if="action.actionCurrentAssignedUser">
                    {{action.actionCurrentAssignedUser[0].first_name ? action.actionCurrentAssignedUser[0].first_name : '' }} {{action.actionCurrentAssignedUser[0].last_name ? action.actionCurrentAssignedUser[0].last_name : ''}}
                </div>
                <div class="pr-3 assigned-user" :id="actionAssignedUserID" v-if="!action.actionCurrentAssignedUser">
                    {{ $t('toolkit.action.unassigned') }}
                </div>
                <span :id="actionAssignUserTriggerID" class="material-icons-outlined" aria-role="button" aria-label="Assign action to user">edit_note</span>
            </div>

            <div :id="actionAssignUserSelectWrapper" class="form-control assign-user-select" aria-live="polite">

                <multiselect
                    :disabled="preview || adminAudit || !editable"
                    :id="actionAssignUserSelect"
                    :options="props.currentToolkitTeamUsers"
                    v-model="assignedUser.user_id"
                    label="full_name"
                    track-by="full_name"
                    valueProp="id"
                    :placeholder="$t('toolkit.action.assign')"
                    :searchable="true"
                    :allow-empty="false"
                    @select="UpdateAssignedUser"
                    class="w-full border-gray-300 rounded-md md:mr-5 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                    >
                </multiselect>

            </div>
        </div>
        <div class="mt-5 break "></div>
        <div class="flex-col auditor-comments xl:w-3/4" v-if="auditor || (toolkit.display_audit_info_to_user && (action.auditor_comments && action.auditor_comments.length > 0))">
            <div class="flex items-center">
                <h4 class="font-bold">{{ $t('auditor.action.comments') }}</h4>
            </div>
            <div class="flex items-center grow ">
                <div class="w-full p-5 mb-5 text-center card-item action-card-item action-card-controls rounded-2xl xl:mr-5">
                    <AuditorComment v-for="auditor_comment in action.auditor_comments" :comment="auditor_comment" :loggedInUserId="loggedInUserId" :filters="props.filters" :contains_draft_auditor_comment="action.contains_draft_auditor_comment" :auditorSession=props.auditorSession :pastToolkit="props.pastToolkit" />
                    <div class="pt-5 comment-editor" v-if="auditor">
                        <QuillEditor
                            ref="auditorCommentEditor"
                            v-model:content="auditorCommentForm.auditorComment"
                            ctheme="snow"
                            contentType="html"
                            :read-only="adminAudit"
                             />
                             <div v-if="auditorCommentForm.auditorDraftLastSaved" class="mt-1 text-xs text-gray-500 last-updated">{{ $t('toolkit.comment.last_updated') }}: {{ formatDate(auditorCommentForm.auditorDraftLastSaved) }}</div>
                        <div class="w-full pt-3">
                            <JetButton
                            :disabled='action.inactive || preview || adminAudit'
                            type="button"
                            class="justify-center block mb-2 rounded btn-save-comment btn btn-action-control btn-toolkit-primary sm:float-right"
                            v-on:click="saveAuditorComment($event)"
                            >
                            {{ $t('toolkit.action.save_comment') }}
                            </JetButton>
                        </div>
                        <span class="text-red-500">{{validation_error.auditorComment}}</span>
                    </div>



                </div>
            </div>
        </div>
        <div class="flex-col auditor-actions xl:w-1/4" v-if="auditor">
            <div class="flex items-center">
                <h4 class="font-bold">{{ $t('auditor.action.actions') }}</h4>
            </div>
            <div class="flex items-center">
                <div class="w-full p-5 mb-5 text-center card-item action-card-item action-card-controls rounded-2xl">

                    <JetButton
                        type="button"
                        class="justify-center block w-full mb-3 btn btn-action-control"
                        v-on:click="auditorAcceptStatus($event);"
                        :disabled='adminAudit'
                        :class="action_audit.values && action_audit.values.status_accepted == 1 ? 'btn-toolkit-primary' : 'btn-toolkit-secondary'"
                    >
                    {{ $t( 'auditor.action.accept_status' ) }}

                    </JetButton>

                    <p v-if="action_audit.values.status_accepted">{{ $t( 'auditor.action.accepted' ) }}</p>

                    <div :id="auditorChangeActionStatusSelectWrapper" class="form-control change-status-select" aria-live="polite">
                        <label :for="auditorChangeActionStatusID" class="block mb-2 font-bold">or change status to</label>

                        <p v-if="amendedStatus.statusLabel != 'Unset'">
                            The status has been changed to  <strong>{{ amendedStatus.statusLabel }}</strong>
                        </p>

                        <!-- {{ action_audit.values.amended_status_id }}

                        {{ arrayOfStatuses }} -->

                        <multiselect
                            :id="auditorChangeActionStatusID"
                            :disabled="preview || adminAudit"
                            :options="arrayOfStatuses"
                            :v-model="action_audit.values.amended_status_id"
                            label="name"
                            track-by="id"
                            valueProp="id"
                            placeholder="Update status"
                            :canClear="true"
                            :searchable="false"
                            :close-on-select="true"
                            :allow-empty="true"
                            @select="auditorChangeStatus"
                            @clear="auditorClearStatus"
                            class="w-full border-gray-300 rounded-md md:mr-5 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                            >
                        </multiselect>

                    </div>

                    <div class="pt-3 pb-3 form-control">
                        <input :disabled="adminAudit" type="checkbox" class="mr-2" :name="auditorActionFurtherEvidenceID" :id="auditorActionFurtherEvidenceID" v-on:click="furtherEvidenceRequired($event);" :checked="isFurtherEvidenceRequired()" />
                        <label :for="auditorActionFurtherEvidenceID" class="font-bold">{{ $t( 'auditor.action.further_evidence_required' ) }}</label>
                    </div>

                    <div class="mb-4 form-control">
                        <Datepicker
                            v-model="action_audit.values.evidence_required_by"
                            :ref="dateRequiredBy"
                            :name="auditorRequiredByID"
                            :id="auditorRequiredByID"
                            :disabled="adminAudit"
                            placeholder="Required by date"
                            @update:modelValue="auditorEvidenceRequiredByDate"
                        />
                    </div>
                    <hr class="mt-3 mb-3"/>
                    <div class="pb-2 form-control">

                        <label :for="auditorChangeActionPointsID" class="block mb-2 font-bold">{{ $t( 'auditor.action.change_points_value' ) }}</label>
                        <div class="flex items-center justify-between">
                            <input :disabled="adminAudit" type="number" v-model="action_audit.values.amended_points_value" class="w-full p-1 mr-2 border-gray-300 rounded-md md:mr-5 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50" :name="auditorChangeActionPointsID" :id="auditorChangeActionPointsID" />
                            <JetButton
                                :disabled="adminAudit"
                                type="button"
                                class="btn-toolkit-primary"
                                @click="auditorChangeActionPoints"
                            >
                            {{ $t( 'auditor.action.change_points_value_button' ) }}
                            </JetButton>
                        </div>
                    </div>
                    <hr class="mt-3 mb-3"/>
                    <JetButton
                        type="button"
                        class="justify-center block w-full mt-3 mb-3 btn-toolkit-primary"
                        :class="{ 'opacity-25': enabling }" :disabled="enabling || !evidence" v-on:click="downloadEvidenceForAction"
                    >
                    {{ $t( 'auditor.action.download_evidence' ) }}
                    </JetButton>

                </div>
            </div>
        </div>
        <div class="flex-col auditor-actions xl:w-1/4" v-if="pastToolkit && (action.action_audit && action.action_audit.length > 0) && toolkit.display_audit_info_to_user">
            <div class="flex items-center">
                <h4 class="font-bold">{{ $t('auditor.action.actions') }}</h4>
            </div>
            <div class="flex items-center">
                <div class="w-full p-5 mb-5 text-center card-item action-card-item action-card-controls rounded-2xl">
                    <p v-if="action.action_audit[0].status_accepted">{{ $t( 'auditor.action.accepted' ) }}</p>
                    <p v-else-if="action.action_audit[0].amended_status_id">{{ $t( 'auditor.action.suggested_status_change' ) }} {{ getStatusLabel(action.action_audit[0].amended_status_id) }}</p>
                    <p v-if="action.action_audit[0].amended_points_value">{{ $t( 'auditor.action.suggested_points_change' ) }} {{ action.action_audit[0].amended_points_value }}</p>
                    <p v-if="action.action_audit[0].further_evidence_required">
                        {{ $t( 'auditor.action.further_evidence_required' ) }}
                        <span v-if="action.action_audit[0].evidence_required_by"> by {{ formatDate(action.action_audit[0].evidence_required_by, false) }}</span>
                    </p>
                </div>
            </div>
        </div>

    </div>

    <JetDialogModalForm :show="uploadEvidence" :maxWidth="modalSize" @close="closeModal">
        <template #content>
            <div class="p-5">
                <JetFormSection @submitted="Upload">
                    <template #form>
                        <div class="px-6 py-4">
                            <div class="text-lg">
                                <span class="text-lg font-bold">{{ $t('toolkit.action.evidence_upload.title') }} {{action.reference}}</span>
                            </div>

                            <div class="mt-4">
                                <span class="font-bold text-red-500">{{ $t('toolkit.action.evidence_upload.warning') }}</span>
                                <div class="text-darkgray-300">{{ $t('toolkit.action.evidence_upload.warning_additional') }}</div>

                                <div class="p-6 mt-4 border-2 border-black border-solid rounded">
                                    <input name="file_path" @input="evidenceForm.file_path = $event.target.files[0]" ref="uploadFile" type="file" tabindex="-1" />
                                </div>
                                <span class="text-red-500">{{validation_error.file_path}}</span>
                            </div>
                        </div>

                        <div class="flex flex-row justify-end px-6 py-4 text-right bg-gray-100">
                            <JetSecondaryButton @click="closeModal">
                                {{ $t('toolkit.action.evidence_upload.cancel') }}
                            </JetSecondaryButton>

                            <JetButton
                                class="ml-3"
                                :class="{ 'opacity-25': form.processing }"
                                :disabled="form.processing || action.inactive"
                            >
                                {{ $t('toolkit.action.evidence_upload.confirm') }}
                            </JetButton>
                        </div>
                    </template>
                </JetFormSection>
            </div>
        </template>
    </JetDialogModalForm>

</template>

